import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PersistSettingsBackendService } from './persist-settings-backend.service';
import { PersistSettingsLocalService } from './persist-settings-local.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [PersistSettingsBackendService, PersistSettingsLocalService],
})
export class CommonPersistencyModule {}
